import type { SVGProps } from 'react';

const SvgColorProfileEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <rect width={96} height={96} fill="#F5F5F5" rx={48} />
    <g clipPath="url(#ColorProfileEmpty_svg__a)">
      <path
        fill="#B7B7B7"
        d="M48 36c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4m0 20c5.4 0 11.6 2.58 12 4H36c.46-1.44 6.62-4 12-4m0-24c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8m0 20c-5.34 0-16 2.68-16 8v4h32v-4c0-5.32-10.66-8-16-8"
      />
    </g>
    <defs>
      <clipPath id="ColorProfileEmpty_svg__a">
        <path fill="#fff" d="M24 24h48v48H24z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgColorProfileEmpty;
